/**
 * Models an alternative chain seen by the node.
 */
export default class MoneroAltChain {
    constructor(altChain) {
        Object.assign(this, altChain);
        if (this.difficulty !== undefined && typeof this.difficulty !== "bigint")
            this.difficulty = BigInt(this.difficulty);
    }
    toJson() {
        let json = Object.assign({}, this);
        if (this.getDifficulty() !== undefined)
            json.difficulty = this.getDifficulty().toString();
        return json;
    }
    getBlockHashes() {
        return this.blockHashes;
    }
    setBlockHashes(blockHashes) {
        this.blockHashes = blockHashes;
        return this;
    }
    getDifficulty() {
        return this.difficulty;
    }
    setDifficulty(difficulty) {
        this.difficulty = difficulty;
        return this;
    }
    getHeight() {
        return this.height;
    }
    setHeight(height) {
        this.height = height;
        return this;
    }
    getLength() {
        return this.length;
    }
    setLength(length) {
        this.length = length;
        return this;
    }
    getMainChainParentBlockHash() {
        return this.mainChainParentBlockHash;
    }
    setMainChainParentBlockHash(mainChainParentBlockHash) {
        this.mainChainParentBlockHash = mainChainParentBlockHash;
        return this;
    }
}
